// device.service.ts
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DeviceService {
  isMobile(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    return /android|iphone|ipad|ipod|windows phone/i.test(userAgent.toLowerCase());
  }

  isDesktop(): boolean {
    return !this.isMobile();
  }
}
